import React from 'react';
import { errors } from '@feathersjs/client';
import * as Raven from 'raven-js';
import message from 'antd/lib/message';
import 'antd/lib/message/style/index.css';
import ReconnectSocket from 'src/pages/components/utilities/ReconnectSocket';
export default function setSocketListeners() {
    if (!window.socket) {
        throw new errors.GeneralError('setSocketListeners ran before socket was initialized');
    }
    window.socket.on('connect', function (err) {
        setTimeout(function () { message.destroy(); }, 1000);
    });
    window.socket.on('connect_timeout', function (err) {
        message.destroy();
        message.warn(React.createElement("div", { className: 'wrapper' },
            "Could not connect to CRIMP. ",
            React.createElement(ReconnectSocket, { displayText: 'Try again?' })), 0);
    });
    window.socket.on('reconnect', function () {
        message.destroy();
        message.success('We\'re back online!', 1);
    });
    window.socket.on('reconnect_error', function (err) {
        message.destroy();
        message.warn(React.createElement("div", { className: 'wrapper' },
            "Could not connect to CRIMP. ",
            React.createElement(ReconnectSocket, { displayText: 'Try again?' })), 0);
    });
    window.socket.on('reconnecting', function () {
        message.destroy();
        message.loading('Reconnecting...', 0);
    });
    window.socket.on('disconnect', function (options) {
        message.destroy();
        message.warn(React.createElement("div", { className: 'wrapper' },
            "You've disconnected from CRIMP.",
            React.createElement("br", null),
            React.createElement(ReconnectSocket, { displayText: 'Try to reconnect?' })), 0);
    });
    window.socket.on('error', function (err) {
        Raven.captureException(err);
        message.destroy();
        message.warn(React.createElement("div", { className: 'wrapper' },
            "Connection error to CRIMP.",
            React.createElement("br", null),
            React.createElement(ReconnectSocket, { displayText: 'Try to reconnect?' })), 0);
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/feathers/setSocketListeners.tsx
// module id = 437
// module chunks = 0